'use client'
import { useContext, useEffect } from 'react'
import { Button, ButtonProps } from '../Buttons'
import { MeetingsContext } from './context'

interface MeetingHandlerProps {
  children: React.ReactNode
  buttonProps: Omit<ButtonProps, 'onClick'>
  meetingLink: string
  onClick?: () => void
}

export function MeetingButton({
  buttonProps = { theme: 'secondary' },
  children,
  meetingLink,
  onClick,
}: MeetingHandlerProps) {
  const { openDialog, addMeetingLink } = useContext(MeetingsContext)
  useEffect(() => {
    if (addMeetingLink && meetingLink) {
      addMeetingLink(meetingLink)
    }
  }, [addMeetingLink, meetingLink])

  const open = (e: React.MouseEvent) => {
    e.stopPropagation()
    onClick && onClick()
    openDialog && openDialog(meetingLink)
  }
  return (
    <Button variant="solid" {...buttonProps} onClick={open} centerTextBlock>
      {children}
    </Button>
  )
}
